<template>
    <div class="dashboard">
      <h1 class="text-3xl font-bold mb-6 text-gray-800">Dashboard</h1>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
     <!--   <SurveyOverview /> -->
        <UserGroupManagement />
        <AdminActions v-if="isSuperAdmin" />
      </div>
    </div>
  </template>
  
  <script>
  import SurveyOverview from './SurveyOverview.vue'
  import AdminActions from './AdminActions.vue'
  import UserGroupManagement from './UserGroupManagement.vue'
  import { mapState } from 'vuex';
  
  export default {
    name: 'Dashboard',
    components: {
      SurveyOverview,
      AdminActions,
      UserGroupManagement
    },
    computed: {
      ...mapState({
        userRole: state => state.auth.userRole
      }),
      isSuperAdmin() {
        return this.userRole === 'admin';
      }
    }
  }
  </script>
  
  